module.exports = __webpack_public_path__ + "img/banner_01.356f31f2.jpg";